export const CONSENT_COOKIE_NAME = "taroterra_consent";
export const CONSENT_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 year

export type ConsentStatus = "granted" | "denied";

export function isConsentStatus(value: string | null | undefined): value is ConsentStatus {
  return value === "granted" || value === "denied";
}

export function readConsentCookie(): ConsentStatus | null {
  if (typeof document === "undefined") {
    return null;
  }

  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${CONSENT_COOKIE_NAME}=(granted|denied)(?:;|$)`)
  );

  return match ? (match[1] as ConsentStatus) : null;
}

function shouldSetSharedDomain(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  const { hostname } = window.location;
  return hostname === "taroterra.com" || hostname.endsWith(".taroterra.com");
}

export function writeConsentCookie(status: ConsentStatus): void {
  if (typeof document === "undefined") {
    return;
  }

  const parts = [
    `${CONSENT_COOKIE_NAME}=${status}`,
    "Path=/",
    `Max-Age=${CONSENT_COOKIE_MAX_AGE_SECONDS}`,
    "SameSite=Lax",
  ];

  if (shouldSetSharedDomain()) {
    parts.push("Domain=.taroterra.com");
  }

  if (window.location.protocol === "https:") {
    parts.push("Secure");
  }

  document.cookie = parts.join("; ");
}
